import type { KeyboardEvent as ReactKeyboardEvent } from "react";

export const loadScript = ({
  id,
  src,
  onLoad = (): void => {},
  onError = (): void => {},
  defer = null,
}): void => {
  if (document.getElementById(id)) {
    onLoad();
    return;
  }
  const js = document.createElement("script");
  js.id = id;
  js.src = src;
  if (defer) {
    js.setAttribute("defer", "");
  }
  document.head.appendChild(js);
  js.onerror = onError;
  js.onload = onLoad;
};

export const KeyCodes = {
  Enter: (event: ReactKeyboardEvent<HTMLInputElement>): boolean =>
    event.key === "Enter",
};
